import { withGlobalOptions } from '../types'
import { fetchProduct } from './fetch'
import { fetchMultipleProducts } from './fetch-multiple'

export const productHandles = withGlobalOptions({
  fetch: fetchProduct,
  fetchMultiple: fetchMultipleProducts,
})
